import immersiveReaderProcessTextOperation from 'owa-service/lib/operation/immersiveReaderProcessTextOperation';
export default function immersiveReaderProcessText(itemId, sessionId, version, requestOptions) {
    return immersiveReaderProcessTextOperation({
        itemId: itemId,
        sessionId: sessionId,
        version: version,
    }, requestOptions);
}
//# sourceMappingURL=immersiveReaderProcessText.js.map